import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { LineDirectionCountersResetsService } from '../../line-direction-counters-reset.service';
import { RouteQuery } from './form/find-route-form/find-route-form.component';

@Component({
  selector: 'app-line-direction-counters-resets-add',
  templateUrl: './line-direction-counters-resets-add.component.html',
  styleUrls: ['./line-direction-counters-resets-add.component.scss']
})
export class LineDirectionCountersResetsAddComponent implements OnInit {
  routeQuery: RouteQuery | null = null;
  private editQuery = new Subject<RouteQuery | null>();
  editQuery$ = this.editQuery.asObservable();

  constructor(private route: ActivatedRoute, private resetService: LineDirectionCountersResetsService) { }

  ngOnInit(): void {
    this.updateStateByRoute();
  }

  private updateStateByRoute(): void {
    if (this.route.snapshot.url.find(v => v.path === 'edit') != null) {
      this.resetService.getById(this.route.snapshot.queryParams.id)
        .subscribe(v => {
          const routeQuery = new RouteQuery(v.carrierId, v.line, v.direction);
          this.editQuery.next(routeQuery);
        }, error => {
          console.error(error);
          this.editQuery.next(null);
        });
    }
  }

  handleFormSelected(formValue: RouteQuery): void {
    if (formValue == null) {
      this.routeQuery = null;
    } else {
      this.routeQuery = formValue;
    }
  }

}
